module.exports = __webpack_public_path__ + "img/text.61f20e01.svg";